import { useId, useState } from "react";
import { Input } from "antd";
import DirectionalIcon from "../../../features/navigation/DirectionalIcon.tsx";
import { CaretDown } from "@phosphor-icons/react";
import { t, useStoreLanguage } from "../../../features/store-language/i18n.ts";

// Mirrors Raj's DocumentEditorNotesSection, including its collapsed preview.
export default function AccountOrderNotes({ description, disabled, isEditMode, onChange }: {
  description: string;
  disabled: boolean;
  isEditMode: boolean;
  onChange: (description: string) => void;
}) {
  useStoreLanguage();
  const [expanded, setExpanded] = useState(false);
  const bodyId = useId();
  const trimmedDescription = description.trim();
  const preview = trimmedDescription || (isEditMode ? t("بدون توضیحات") : null);

  return (
    <section className="account-order-notes">
      <button
        type="button"
        className="account-order-notes__toggle"
        aria-controls={bodyId}
        aria-expanded={expanded}
        onClick={function () { setExpanded(function (current) { return !current; }); }}
      >
        <span className="account-order-notes__label">{t("توضیحات")}</span>
        {!expanded && preview ? (
          <span className={"account-order-notes__preview" + (trimmedDescription ? "" : " account-order-notes__preview--empty")}>
            {preview}
          </span>
        ) : null}
        {expanded ? (
          <CaretDown
            className="account-order-notes__icon"
            size={20}
            aria-hidden="true"
          />
        ) : (
          <DirectionalIcon
            direction="forward"
            variant="chevron"
            className="account-order-notes__icon"
            size={20}
          />
        )}
      </button>
      <div
        id={bodyId}
        className="account-order-notes__body"
        hidden={!expanded}
      >
        <Input.TextArea
          aria-label={t("توضیحات")}
          placeholder={t("توضیحات...")}
          rows={3}
          maxLength={2000}
          disabled={disabled}
          value={description}
          onChange={function (event) { onChange(event.target.value); }}
        />
      </div>
    </section>
  );
}
